/**
 * Surcharges API Queries
 *
 * Query keys and read operations.
 */

import { apiClient } from '../client';
import type { SurchargesListResponse, FetchSurchargesParams } from './types';
import type { SurchargeResponse } from './mutations';

export const surchargesQueryKeys = {
  all: ['surcharges'] as const,
  lists: () => [...surchargesQueryKeys.all, 'list'] as const,
  list: (params: FetchSurchargesParams) => [...surchargesQueryKeys.lists(), params] as const,
  details: () => [...surchargesQueryKeys.all, 'detail'] as const,
  detail: (id: number) => [...surchargesQueryKeys.details(), id] as const,
};

export async function getSurcharges(params: FetchSurchargesParams = {}): Promise<SurchargesListResponse> {
  const { data } = await apiClient.get<SurchargesListResponse>('/api/surcharges', { params });
  return data;
}

export async function getSurcharge(id: number): Promise<SurchargeResponse> {
  const { data } = await apiClient.get<SurchargeResponse>(`/api/surcharges/${id}`);
  return data;
}
